import passionKitchen from 'brands/passion-kitchen'
import { isProduction } from 'variables/environment'
import { BrandConfigType } from 'types'
import { getBrandDefaultFeatures } from 'brands'

const brand: BrandConfigType = {
  ...passionKitchen,
  liffID: {
    ...passionKitchen.liffID,
    home: isProduction ? '1578956419-dpjgPeoX' : '1657129684-wXyNnGv2',
    lineID: isProduction ? '@747djzxj' : '@844gqoba',
  },
  label: `Bar B Q Plaza`,
  id: isProduction ? 78 : 173,
  title: 'GON member',
  slogan: `สั่ง GON กลับบ้านอร่อยเหมือนกินที่ร้าน
  พร้อมบริการยืมเตาไม่ต้องล้าง
  (ให้บริการในเขตกรุงเทพฯ - ปริมณฑล 55 สาขา)`,
  brandSelectImg: `${process.env.PUBLIC_URL}/assets/brand/icon-brand-bbq-optimized.png`,
  registerUrl: 'https://liff.line.me/1578956419-k3yNBDE8',
  connectMembershipUrl: isProduction
    ? 'https://liff.line.me/1578956419-gl26m4wN'
    : 'https://liff.line.me/1649469421-YbavlVAw',
  checkout: {
    enableRequestTaxInvoice: false,
  },
  features: getBrandDefaultFeatures({
    dineIn: {
      contactStaffToMakePayment: true,
    },
    hatostore: { enableETax: true },
  }),
}

export default brand
